export default {

  methods: {
  
    call_LINK(selection, idx, y, col) {
      
      if(col.filter == '') return

      this.gmx_valueHovor(selection, `${col.code}_${idx}_${this.localId}`, col.x, y, col.align, col.tColor, '#EC407A',)
      selection
      .on('click', () => { 
        let dataSource = {}

        Object.keys(this.keys).forEach(d=>{
          dataSource = {...dataSource, [d]: this.rawData[idx][this.keys[d]]}
        })

        // ********************************************************************************
        console.log('dataSource: ', dataSource)
        let filterTesting = col.filter !== '' ? this.filters[col.filter] : ''
        console.log('filterString_: ', filterTesting)
        // ********************************************************************************

        // Mapping the filter(value) to JsonProps in A/G 
        let request_ = this.getRequestColumnProps('request', dataSource, this.ColumnProps)
        if(!request_) return

        // set for filterString 
        let filterString_ = col.filter !== '' ? this.filters[col.filter] : ''
        
        // if A/G filterString is exist, set request_.iFilters.filterString + filterString_
        if(request_.iFilters.filterString) {
          request_.iFilters.filterString += filterString_ ? ` AND ${filterString_} ` : ''
        } else {
          request_.iFilters.filterString = filterString_||''
        }

        // combine filterString and inputFilter &&& emit request-action
        request_ = {...request_,
          filters : {
            ...this.FilterValues,
            ...request_.filters,
          },
          iFilters: { 
            filterString : request_.iFilters.filterString||'',
            inputFilter : request_.iFilters.inputFilter,},
        }
        this.$emit('request-action', request_)
      })
    }, 

  }
}